import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";

import auth from "./auth";
import starter from "./starter";
import dashboard from "./dashboard";
import app from "./app";
import appFinances from "./appExpandedReducers/finances";
import appProperties from "./appExpandedReducers/properties";
import appCommunities from "./appExpandedReducers/communities";
import finances from "./finances";
import users from "./users";
import merchants from "./merchants";
import website from "./website";

const rootReducer = combineReducers({
  auth,
  routing: routerReducer,
  starter,
  dashboard,
  app,
  website,
  appFinances,
  appProperties, 
  appCommunities,
  finances,
  users,
  merchants,
});

export default rootReducer;